import { AlertTitle, Button, Chip, Stack, styled } from "@mui/material";
import React from "react";
import uscaLogo from "./core/assets/images/logos/usca-logo.png";
import ansLogo from "./core/assets/images/logos/ans-logo-2.png";
import LinkedIn from "@mui/icons-material/LinkedIn";
import { Mail, OpenInNew } from "@mui/icons-material";
import ContributorsDialog from "./components/Dialogs/ContributorsDialog";

const StyledChip = styled(Chip)({
  margin: "0.2rem",
});

const Footer = () => {
  return (
    <Stack alignItems="center" mt="1.25em">
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="center"
      >
        <span>Made with &#10084; by</span>
        <StyledChip
          size="small"
          component="a"
          target="_blank"
          onClick={() => {}}
          href="https://www.linkedin.com/in/wei-zheng-633597179/"
          icon={<LinkedIn />}
          label="Wei Zheng"
        />
        <StyledChip
          size="small"
          component="a"
          target="_blank"
          onClick={() => {}}
          href="https://www.linkedin.com/in/joseph-taylor-93355965"
          icon={<LinkedIn />}
          label="Joe Taylor"
        />
        <StyledChip size="small" label="Drake Jones" />
      </Stack>

      <br />
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="center"
      >
        <span>Inspired by</span>
        <StyledChip size="small" label="Bill Wabbersen" />
        <StyledChip
          size="small"
          label="Rao Li"
          component="a"
          target="_blank"
          onClick={() => {}}
          icon={<OpenInNew />}
          href="https://sciences.usca.edu/math/~mathdept/rli/"
        />
      </Stack>
      <br />
      <Stack
        direction="row"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="center"
      >
        <span>Additional data provided by</span>
        <ContributorsDialog />
      </Stack>
      <br />
      <br />
      <AlertTitle>Special Thanks to</AlertTitle>
      <img
        src={ansLogo}
        alt="ans logo"
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "60%",
        }}
      />
      <img
        src={uscaLogo}
        alt="usca logo"
        style={{
          width: "auto",
          height: "auto",
          maxWidth: "40%",
          maxHeight: "200px",
        }}
      />
      <Button
        startIcon={<Mail />}
        fullWidth
        component="a"
        href="mailto:wjzheng0191@gmail.com;succotash2005@yahoo.com;drakejones93@yahoo.com;jrt123@hotmail.com"
        variant="contained"
        sx={{ borderRadius: 0 }}
      >
        Feedback/Report Bug
      </Button>
    </Stack>
  );
};

export default Footer;
